import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Router} from '@angular/router';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {ModalController, PopoverController} from '@ionic/angular';
import {AccountPaymentFavoriteService} from '@wlp/ui-bs-account-payment-favorite';
import {BilletLotService} from '@wlp/ui-bs-cashin';
import {UserInfoService} from '@wlp/ui-bs-login';
import * as moment from 'moment';
import {LoadingService} from 'src/app/core/layout/services/loading.service';

@Component({
    selector: 'ui-t-form-abatement',
    templateUrl: './form-abatement.html',
    styleUrls: ['./form-abatement.scss'],
})
export class FormAbatement implements OnInit {

    @Input() public value: string;
    @Output() public submitForm = new EventEmitter<string>();
    @Output() public onCancel = new EventEmitter<string>();
  public abatementForm: FormGroup;

    constructor(
        private formBuilder: FormBuilder,
        public modalController: ModalController,
        public popoverController: PopoverController,
        public router: Router,
        protected userInfoService: UserInfoService,
        public billetLotService: BilletLotService,
        public accountPaymentFavoriteService: AccountPaymentFavoriteService,
        private loadingService: LoadingService,
    ) {
        moment.locale('pt-br');
    }

  public ngOnInit() {
        this.createAbatementForm();
    }

  public createAbatementForm() {
        const initialValue = Number(this.value).toFixed(2);
        this.abatementForm = this.formBuilder.group({
            abatement: new FormControl(initialValue, Validators.compose([Validators.required, Validators.min(1)])),
        });
        this.loadingService.hide();
    }

  public handleClickSaveButton() {
        const abatement = this.validateAbatement();
        if (abatement != false) {
            this.submitForm.emit();
        }
    }

  public validateAbatement() {
        const abatement = this.abatementForm.get('abatement').value;
        this.abatementForm.controls['abatement'].markAsTouched();
        if (!this.abatementForm.valid) {
            return false;
        }
        return abatement;
    }

  public cancel() {
        this.onCancel.emit();
    }

}
